  <header class="top-navbar" [style.zIndex]="tutorialStep > 0 ? '3000' : '1000'">
    <div class="navbar-left">
      <button class="mobile-toggle" *ngIf="isMobileView" (click)="toggleSidebar()">
        <i class="fa-solid fa-bars"></i>
      </button>
      <div class="logo-container">
        <div class="logo-row">
          <img class="logo-text" src="assets/logo-text.png" alt="alugul">
          <div class="logo-icon-wrap">
            <span class="puff p1"></span>
            <span class="puff p2"></span>
            <span class="puff p3"></span>
            <span class="puff p4"></span>
            <img class="logo-icon" src="assets/logo-icon.png" alt="">
            <div class="tracks">
              <span class="track"></span><span class="track"></span><span class="track"></span>
              <span class="track"></span><span class="track"></span><span class="track"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="navbar-right">
      <button class="plan-btn" (click)="openVehiclePlanDialog()" disabled>
        <i class="fa-solid fa-bolt"></i>
        <span class="plan-btn-label">Upgrade</span>
      </button>

      <div class="notification-container relative">
        <button class="icon-btn" (click)="toggleNotification($event)">
          <i class="fa-regular fa-bell"></i>
          <span class="badge" *ngIf="unreadNotificationCount$ | async as count">{{ count }}</span>
        </button>
        <div class="notification-dropdown" *ngIf="notificationOpen" (click)="$event.stopPropagation()">
          <div class="notification-header">
            <h3>Notifications (last 7 days)</h3>
          </div>
          <div class="notification-list">
            <div class="notification-item" *ngFor="let note of notifications$ | async" [class.unread]="!note.isRead"
              (click)="handleNotificationClick(note)">
              <div class="note-icon">
                <span class="material-icons" [ngClass]="note.type">info</span>
              </div>
              <div class="note-content">
                <h4>{{ note.title }}</h4>
                <p>{{ note.message }}</p>
                <span class="note-time">{{ note.createdAt?.toDate() | date: "short" }}</span>
              </div>
            </div>
            <div class="empty-state" *ngIf="(notifications$ | async)?.length === 0">
              <p>No notifications yet</p>
            </div>
          </div>
          <div class="notification-footer">
            <span (click)="viewAllNotifications()">View All</span>
            <span class="clear-all" (click)="clearAllNotifications()">Clear All</span>
          </div>
        </div>
      </div>

      <button class="user-menu-btn" [matMenuTriggerFor]="userAccountMenu">
        <div class="avatar-circle">{{ currentusername.charAt(0) }}</div>
        <i class="fa-solid fa-bars"></i>
      </button>
      <mat-menu #userAccountMenu="matMenu">
        <app-profilecard *ngIf="currentuid" [uid]="currentuid" [planName]="planBadgeName" [planColor]="planBadgeColor">
        </app-profilecard>
      </mat-menu>
    </div>
  </header>

  <div class="layout-body">
    <aside class="sidebar-container" [class.closed]="!sidebarOpen && isMobileView"
      [style.overflow]="tutorialStep > 0 ? 'visible' : 'auto'" [style.zIndex]="tutorialStep > 0 ? '2002' : '900'">

      <!-- ── Greeting block ──────────────────────────────── -->
      <div class="sidebar-top-block">
        <div class="greeting-name">Hello, {{ currentusername }}</div>
        <div class="greeting-date">{{ today | date: "EEEE, MMMM d, y" }}</div>
      </div>

      <!-- ── Plan summary card ───────────────────────────── -->
      <div class="sidebar-plan-wrap" *ngIf="planBadgeName" [style.--plan-color]="planBadgeColor">

        <div class="plan-card-header">
          <div class="plan-card-header-left">
            <div class="plan-header-label">Subscription</div>
            <div class="plan-header-name">{{ planBadgeName }}</div>
          </div>
          <span class="plan-status-pill">
            <span class="plan-status-dot"></span>Active
          </span>
        </div>

        <div class="plan-card-meta" *ngIf="planRenewalDate">
          <span class="plan-meta-item">
            <i class="fa-regular fa-calendar-check"></i>
            {{ currentPlanId === 'free_trial' ? 'Trial ends' : 'Renews' }} {{ planRenewalDate | date: 'MMM d, y' }}
          </span>
        </div>

        <div class="plan-card-actions">
  <button class="plan-manage-btn" (click)="openPlanModal()" disabled>
    <i class="fa-solid fa-sliders"></i>
    Manage plan
  </button>
  <button class="plan-upgrade-btn" (click)="navigateToUpgrade()" disabled>
    <i class="fa-solid fa-arrow-up-right-dots"></i>
  </button>
</div>

      </div>

      <!-- ── Section divider before nav ─────────────────── -->
      <div class="sidebar-section-divider">
        <span class="sidebar-section-label">Vendor Dashboard</span>
      </div>

      <!-- ── Navigation ─────────────────────────────────── -->
      <nav class="sidebar-nav">
        <ng-container *ngFor="let item of menuItems">
          <div class="nav-header" *ngIf="item.isHeader">{{ item.label }}</div>
          <div class="nav-link" *ngIf="!item.isHeader" [class.active]="item.active" [class.highlight-tutorial]="
              (tutorialStep === 2 && item.route === '/business/equipment') ||
              (tutorialStep === 3 && item.route === '/business/booking') ||
              (tutorialStep === 4 && item.route === '/business/listed-equipment') ||
              (tutorialStep === 5 && item.route === '/business/notifications') ||
              (tutorialStep === 6 && item.route === '/business/customer-history') ||
              (tutorialStep === 7 && item.route === '/business/drive') ||
              (tutorialStep === 8 && item.route === '/business/equipment/add')
            " (click)="navigateTo(item)">
            <i [class]="item.icon"></i>
            <span>{{ item.label }}</span>
            <span *ngIf="item.badge && item.badge > 0" class="menu-badge">{{ item.badge }}</span>
            <span *ngIf="item.isPremium" class="premium-badge">PREMIUM</span>

            <div class="tutorial-tooltip" *ngIf="tutorialStep === 2 && item.route === '/business/equipment'">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-content">
                <div class="tooltip-header">// QUICK TOUR</div>
                <h4 class="tooltip-title">Manage Equipment 🚛</h4>
                <p class="tooltip-desc">This is where you can see all your listed vehicles and equipments, track their
                  status, and manage updates.</p>
                <div class="tooltip-footer">
                  <div class="step-info">Step 1 of 7</div>
                  <div class="footer-actions">
                    <button class="skip-btn" (click)="prevTutorialStep($event)">&larr; Previous</button>
                    <button class="next-btn" (click)="nextTutorialStep($event)">Next &rarr;</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="tutorial-tooltip" *ngIf="tutorialStep === 3 && item.route === '/business/booking'">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-content">
                <div class="tooltip-header">// QUICK TOUR</div>
                <h4 class="tooltip-title">Booking Requests 📅</h4>
                <p class="tooltip-desc">Check here for incoming booking requests from customers. You can accept or reject
                  them, manually add enquiries and bookings, and attach all related documents from this page.</p>
                <div class="tooltip-footer">
                  <div class="step-info">Step 2 of 7</div>
                  <div class="footer-actions">
                    <button class="skip-btn" (click)="prevTutorialStep($event)">&larr; Previous</button>
                    <button class="next-btn" (click)="nextTutorialStep($event)">Next &rarr;</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="tutorial-tooltip" *ngIf="tutorialStep === 4 && item.route === '/business/listed-equipment'">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-content">
                <div class="tooltip-header">// QUICK TOUR</div>
                <h4 class="tooltip-title">Listed Equipment 🌐</h4>
                <p class="tooltip-desc">View and manage the equipment you've listed on the Aluguloo marketplace and keep track of their listing status.</p>
                <div class="tooltip-footer">
                  <div class="step-info">Step 3 of 7</div>
                  <div class="footer-actions">
                    <button class="skip-btn" (click)="prevTutorialStep($event)">&larr; Previous</button>
                    <button class="next-btn" (click)="nextTutorialStep($event)">Next &rarr;</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="tutorial-tooltip" *ngIf="tutorialStep === 5 && item.route === '/business/notifications'">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-content">
                <div class="tooltip-header">// QUICK TOUR</div>
                <h4 class="tooltip-title">Notifications 🔔</h4>
                <p class="tooltip-desc">Stay updated on important booking activity, customer actions, and other updates that may need your attention.</p>
                <div class="tooltip-footer">
                  <div class="step-info">Step 4 of 7</div>
                  <div class="footer-actions">
                    <button class="skip-btn" (click)="prevTutorialStep($event)">&larr; Previous</button>
                    <button class="next-btn" (click)="nextTutorialStep($event)">Next &rarr;</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="tutorial-tooltip tooltip-bottom-aligned" *ngIf="tutorialStep === 6 && item.route === '/business/customer-history'">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-content">
                <div class="tooltip-header">// QUICK TOUR</div>
                <h4 class="tooltip-title">Customer Directory 👥</h4>
                <p class="tooltip-desc">Keep your customer information organised and quickly access customer details whenever you need them.</p>
                <div class="tooltip-footer">
                  <div class="step-info">Step 5 of 7</div>
                  <div class="footer-actions">
                    <button class="skip-btn" (click)="prevTutorialStep($event)">&larr; Previous</button>
                    <button class="next-btn" (click)="nextTutorialStep($event)">Next &rarr;</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="tutorial-tooltip tooltip-bottom-aligned" *ngIf="tutorialStep === 7 && item.route === '/business/drive'">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-content">
                <div class="tooltip-header">// QUICK TOUR</div>
                <h4 class="tooltip-title">Drive 📁</h4>
                <p class="tooltip-desc">Keep your important business, customer, booking, and equipment documents organised and easily accessible.</p>
                <div class="tooltip-footer">
                  <div class="step-info">Step 6 of 7</div>
                  <div class="footer-actions">
                    <button class="skip-btn" (click)="prevTutorialStep($event)">&larr; Previous</button>
                    <button class="next-btn" (click)="nextTutorialStep($event)">Next &rarr;</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="tutorial-tooltip" *ngIf="tutorialStep === 8 && item.route === '/business/equipment/add'">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-content">
                <div class="tooltip-header">// QUICK TOUR</div>
                <h4 class="tooltip-title">Start Here! 🚀</h4>
                <p class="tooltip-desc">Ready? Let's add your first vehicle or equipment to start accepting bookings from
                  customers.</p>
                <div class="tooltip-footer">
                  <div class="step-info">Step 7 of 7</div>
                  <div class="footer-actions">
                    <button class="skip-btn" (click)="prevTutorialStep($event)">&larr; Previous</button>
                    <button class="next-btn" (click)="finishTutorial($event)">Go to Dashboard &rarr;</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </nav>

      <div class="sidebar-footer">
        <span class="version-tag">Version {{ appVersion }}</span>
      </div>
    </aside>

    <main class="main-content-area">
      <router-outlet></router-outlet>
    </main>
  </div>

  <div class="tutorial-backdrop" *ngIf="tutorialStep > 0" (click)="closeTutorial($event)"></div>

  <!-- ── Manage Subscription Modal ────────────────────────────── -->
  <div class="modal-overlay" *ngIf="planModalOpen" (click)="closePlanModal()">
    <div class="modal-sheet" (click)="$event.stopPropagation()">

      <div class="modal-header">
        <div class="modal-header-left">
          <div class="modal-header-icon" [style.background]="(sidebarPlanData?.color ?? '#0ea5e9') + '18'"
            [style.color]="sidebarPlanData?.color ?? '#0ea5e9'">
            <i class="fa-solid fa-layer-group"></i>
          </div>
          <div>
            <div class="modal-title">Manage subscription</div>
            <div class="modal-subtitle" *ngIf="sidebarPlanData">{{ sidebarPlanData.name }} plan</div>
          </div>
        </div>
        <button class="modal-x" (click)="closePlanModal()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <div class="modal-body" *ngIf="sidebarPlanData">

        <!-- Current subscription -->
        <div class="modal-section">
          <div class="section-label">Current subscription</div>
          <div class="info-grid">
            <div class="info-cell">
              <div class="ic-label">Plan</div>
              <div class="ic-value">{{ sidebarPlanData.name }}</div>
            </div>
            <div class="info-cell">
              <div class="ic-label">Status</div>
              <div class="ic-value ic-success">
                <span class="status-dot-inline"></span>Active
              </div>
            </div>
            <div class="info-cell">
              <div class="ic-label">Billing cycle</div>
              <div class="ic-value">{{ sidebarPlanData.term | titlecase }}</div>
            </div>
            <div class="info-cell">
              <div class="ic-label">Renewal date</div>
              <div class="ic-value">{{ sidebarPlanData.renewalDate | date:'MMM d, y' }}</div>
            </div>
            <div class="info-cell">
              <div class="ic-label">{{ currentPlanId === 'free_trial' ? 'Trial fee' : 'Next billing' }}</div>
              <div class="ic-value" [class.ic-success]="currentPlanId === 'free_trial'">
                {{ currentPlanId === 'free_trial' ? 'Free' : 'AED ' + sidebarPlanData.monthlyFee }}
              </div>
            </div>
            <div class="info-cell">
              <div class="ic-label">Auto-renewal</div>
              <div class="ic-value">On</div>
            </div>
          </div>
        </div>

        <!-- Plan features -->
        <div class="modal-section">
          <div class="section-label">Plan features</div>
          <div class="feature-grid">
            <div class="feature-item">
              <span class="feature-icon-wrap"><i class="fa-regular fa-calendar-check"></i></span>
              {{ sidebarPlanData.bookingLimit === 0 ? 'Unlimited' : sidebarPlanData.bookingLimit }} bookings / cycle
            </div>
            <div class="feature-item">
              <span class="feature-icon-wrap"><i class="fa-solid fa-tag"></i></span>
              Listing fee: {{ sidebarPlanData.listingFee === 0 ? 'Free' : 'AED ' + sidebarPlanData.listingFee }}
            </div>
            <div class="feature-item">
              <span class="feature-icon-wrap">
                <i class="fa-solid" [class.fa-wifi]="sidebarPlanData.marketplaceEnabled"
                  [class.fa-wifi-slash]="!sidebarPlanData.marketplaceEnabled"></i>
              </span>
              Marketplace {{ sidebarPlanData.marketplaceEnabled ? 'active' : 'inactive' }}
            </div>
            <div class="feature-item">
              <span class="feature-icon-wrap"><i class="fa-solid fa-list"></i></span>
              {{ sidebarPlanData.activeListingLimit === 0 ? 'Unlimited' : sidebarPlanData.activeListingLimit }} listing
              slots
            </div>
            <div class="feature-item">
              <span class="feature-icon-wrap"><i class="fa-solid fa-database"></i></span>
              {{ sidebarPlanData.storageLimitGb === 0 ? 'Unlimited' : sidebarPlanData.storageLimitGb + ' GB' }} storage
            </div>
            <div class="feature-item">
              <span class="feature-icon-wrap">
                <i class="fa-solid" [class.fa-check]="sidebarPlanData.addOnBookingEnabled"
                  [class.fa-xmark]="!sidebarPlanData.addOnBookingEnabled"></i>
              </span>
              {{ sidebarPlanData.addOnBookingEnabled ? 'Add-on packs available' : 'No add-on packs' }}
            </div>
          </div>
        </div>

        <!-- Current usage -->
        <div class="modal-section">
          <div class="section-label">Current usage</div>
          <div class="usage-grid">
            <div class="usage-cell">
              <div class="usage-num">{{ usageData.bookingsUsed }}</div>
              <div class="usage-sub">Bookings used</div>
            </div>
            <div class="usage-cell">
              <div class="usage-num">{{ usageData.bookingsRemaining }}</div>
              <div class="usage-sub">Remaining</div>
            </div>
            <div class="usage-cell">
              <div class="usage-num">{{ usageData.daysUntilRenewal }}</div>
              <div class="usage-sub">Days to renewal</div>
            </div>
            <div class="usage-cell">
              <div class="usage-num">{{ sidebarPlanData.activeListings }}</div>
              <div class="usage-sub">Active listings</div>
            </div>
            <div class="usage-cell">
              <div class="usage-num">{{ usageData.totalVehicles }}</div>
              <div class="usage-sub">Total vehicles</div>
            </div>
            <div class="usage-cell">
              <div class="usage-num">{{ usageData.storageUsedGb }} GB</div>
              <div class="usage-sub">Storage used</div>
            </div>
          </div>
        </div>

        <!-- Available plans -->
        <!-- Upgrade CTA -->
        <div class="modal-section">
          <div class="section-label">Ready to grow?</div>
          <div class="upgrade-cta-block">
            <div class="upgrade-cta-text">
              <i class="fa-solid fa-arrow-trend-up"></i>
              <div>
                <div class="upgrade-cta-title">Explore available plans</div>
                <div class="upgrade-cta-sub">
                  Compare features, pricing and find the right plan for your business.
                </div>
              </div>
            </div>
            <button class="upgrade-cta-btn" (click)="navigateToUpgrade()">
              View plans <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </div>

        <!-- Billing -->
        <div class="modal-section">
          <div class="section-label">Billing information</div>
          <div class="info-grid">
            <div class="info-cell">
              <div class="ic-label">Renewal date</div>
              <div class="ic-value">{{ sidebarPlanData.renewalDate | date:'MMM d, y' }}</div>
            </div>
            <div class="info-cell">
              <div class="ic-label">Term</div>
              <div class="ic-value">{{ sidebarPlanData.term | titlecase }}</div>
            </div>
            <div class="info-cell">
              <div class="ic-label">Auto-renewal</div>
              <div class="ic-value">Enabled</div>
            </div>
            <div class="info-cell" (click)="navigateToInvoices()" style="cursor:pointer">
              <div class="ic-label">Invoices</div>
              <div class="ic-value ic-link">View all invoices →</div>
            </div>
          </div>
        </div>

      </div>

      <div class="modal-footer">
        <button class="btn-secondary" (click)="closePlanModal()">Close</button>
        <button class="btn-primary" (click)="navigateToUpgrade()">
          Upgrade plan <i class="fa-solid fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>